import { render, staticRenderFns } from "./EditBeneficiaryRightsPopup.vue?vue&type=template&id=d52aeabe&"
import script from "./EditBeneficiaryRightsPopup.vue?vue&type=script&lang=js&"
export * from "./EditBeneficiaryRightsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports